import { Redirect } from 'expo-router';

/**
 * Legacy onboarding step. Property claim is now an in-context action on the
 * structure detail sheet ("Claim Property" button). Bounce inbound traffic
 * to the map so old deep links don't 404; file can be deleted later.
 */
export default function ClaimPropertyRedirect() {
  return <Redirect href="/(tabs)" />;
}
